module.exports = __webpack_public_path__ + "static/restaurant-barcode-qr-code-menu-45d0cc44d29cb4deb9e2d527b9517b5a.png";